export const CircleRed = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="#BF1A2F" />
  </svg>
);
